import { BaseNotificationMessage, NotificationLink } from './base-notification-message';
import { NotificationDetail } from '../../types';

export function EOIRejectedMessage({ notification }: { notification: NotificationDetail }) {
  const { metadata, entityId } = notification.relatedEntity;
  const actionUrl = entityId ? `/buying/offers/${entityId}` : undefined;

  return (
    <BaseNotificationMessage notification={notification}>
      Expression of Interest rejected for{' '}
      <NotificationLink to={actionUrl}>{metadata.opportunityTitle}</NotificationLink>
    </BaseNotificationMessage>
  );
}
